export function mergeObjects(obj1, obj2) {
  const result = {};

  if (obj1) {
    for (const key in obj1) {
      result[key] = obj1[key];
    }
  }

  if (obj2) {
    for (const key in obj2) {
      result[key] = obj2[key];
    }
  }

  return result;
}

export function serializeFormObject(value) {
  const items = [];

  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      items.push(`${encodeURIComponent(key)}=${encodeURIComponent(value[key])}`);
    }
  }

  return items.join('&');
}

export default {
  mergeObjects,
  serializeFormObject,
};
